<template>
    <el-button
        :loading="downloadLoading"
        icon="el-icon-download"
        :size="$store.state.element.elBtnSize"
        @click="handleDownload"
    >
        {{ btnText }}
    </el-button>
</template>

<script>
export default {
    // name:'NfExportExcel',
    // props: {
    //     list: {
    //         required: true,
    //         type: Array
    //     },
    //     tHeader: {
    //         required: true,
    //         type: Array
    //     },
    //     filename: {
    //         type: String,
    //         default: '导出数据'
    //     },
    //     btnText:{
    //         type:String,
    //         default:'导出 excel'
    //     }
    // },
    // data () {
    //     return {
    //         downloadLoading: false,
    //         autoWidth: true,
    //         bookType: 'xlsx'
    //     }
    // },
    // methods: {
    //     handleDownload () {
    //         this.downloadLoading = true
    //   import('./Export2Excel').then(excel => {
    //       const data = this.formatJson(this.tHeader.map(item=>item.prop), this.list)
    //       excel.export_json_to_excel({
    //           header: this.tHeader.map(item=>item.label),
    //           data,
    //           filename: this.filename,
    //           autoWidth: this.autoWidth,
    //           bookType: this.bookType
    //       })
    //       this.downloadLoading = false
    //   })
    //     },
    //     formatJson (filterVal, jsonData) {
    //         return jsonData.map(v => filterVal.map(j => {
    //             return v[j]
    //         }))
    //     }
    // }
}
</script>